import { Link } from 'react-router-dom'
import { ArrowRight, Settings2 } from 'lucide-react'

/**
 * Der frühere Promotions-„Rules"-Tab (eigene lokale Regel-Komponente mit eigenem
 * Conditions-Renderer) war eine zweite, inkonsistente Regel-Oberfläche. Regeln
 * werden jetzt ausschließlich unter /rules verwaltet.
 */
export default function RulesTabRedirect() {
  return (
    <div className="rounded-lg border border-[var(--border)] bg-[var(--background)] p-6">
      <div className="flex items-start gap-3">
        <Settings2 className="mt-0.5 h-5 w-5 text-[var(--muted-foreground)]" />
        <div>
          <h3 className="text-sm font-semibold text-[var(--foreground)]">
            Regeln werden zentral verwaltet
          </h3>
          <p className="mt-1 max-w-prose text-sm text-[var(--muted-foreground)]">
            Promotion-Regeln (Bedingungen, Cooldown, Auto-Apply) pflegst du an einer Stelle
            unter „Regeln". Diese Ansicht wurde dorthin zusammengeführt.
          </p>
          <Link
            to="/rules"
            className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-zinc-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-zinc-800"
          >
            Regeln verwalten <ArrowRight className="h-3.5 w-3.5" />
          </Link>
        </div>
      </div>
    </div>
  )
}
